import './screens.css';
import { el, setText, text } from './walkout.js';
import { speak } from '../sim/sala.js';
import { needs } from './contract.js';

/**
 * Sala, on a screen.
 *
 * One component rather than one per screen, because he is the same man on both
 * and a second copy of six lines of DOM is a second copy that drifts — the
 * offer screen would get a name plate and the aftermath would not, and nobody
 * would notice for a build step.
 *
 * It **reads and does not decide**, like the rest of `src/ui`. Which line he
 * says is `sala.js`'s, out of a JSON file, for the reason the trash talk is:
 * a sentence chosen in the UI is a rule nobody can test without a browser.
 * All this knows is which screen it is standing on.
 */
export function createPromoter({ campaign, screen = 'offer' }) {
  // `speak` reads far more than this off the campaign; `readSala` is where that
  // list lives and it is the one that would throw. What the *component* needs is
  // simply something to hand it.
  needs(campaign, ['gate', 'history', 'ducking', 'offer', 'heat'], {
    who: 'the promoter',
    what: 'campaign',
  });
  const root = el('div', 'promoter');
  root.dataset.screen = screen;

  const who = el('div', 'promoter__who');
  who.append(text('span', 'promoter__name', ''), text('span', 'promoter__title', ''));
  const say = text('div', 'promoter__say', '');
  root.append(who, say);

  return {
    element: root,

    /**
     * Redrawn from the campaign each time the screen goes up.
     *
     * `event` is the fight the aftermath is about. Without one he reads the
     * last fight out of the history, which is what the offer screen wants —
     * the same result, one screen later.
     */
    update(event = null) {
      const said = speak({ campaign, event, screen });
      setText(who.firstChild, said.name);
      setText(who.lastChild, said.title);
      setText(say, said.line?.say ?? '');
      // The band the room is in, so the styling can be as warm as he is.
      root.dataset.room = said.facts.room;
      root.hidden = !said.line;
      return said;
    },
  };
}
